import React from 'react';
import _ from 'underscore';
import {
    Grid,
    Image,
    Segment,
    Table,
    Header
} from 'semantic-ui-react';
import ProfileBioPlans from '../profile_bio_plans';

const ProfileBio = (props) => {
    const {
        name,
        contactNoCountryCode,
        contactNo,
        nric,
        email,
        bankDetail,
        records,
        companies,
    } = props.user
    const { bankNo, branchNo, accountNo} = bankDetail;
    const userMemberType = companies.filter(company => company.memberType.toUpperCase() == 'E').length
    console.log("check log inside profile bio", props.isnotificationOtp)
    var maskedAccountNo = ''
    if (accountNo && accountNo.length > 0) {
        const last4Digits = accountNo.slice(-4)
        maskedAccountNo = last4Digits.padStart(accountNo.length, '*')
    }

    return (
        <Grid centered>
            {/*
                <Grid.Column width={2}>
                    <Image src={props.profilePhoto} fluid circular />
                </Grid.Column>
            */}

            <Grid.Column width={3}>
                <Image src={props.profilePhoto} circular size='medium'/>
            </Grid.Column>

            <Grid.Column width={16}>

                <Grid columns={2}>
                    <Grid.Column>
                        <Header as='h4' attached='top' block>
                            Personal Information
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            Name
                                        </Table.Cell>
                                        <Table.Cell>
                                            {name}
                                        </Table.Cell>
                                    </Table.Row>
                                    {/*
                                        <Table.Row>
                                            <Table.Cell>
                                                National ID
                                            </Table.Cell>
                                            <Table.Cell>
                                                {nric}
                                            </Table.Cell>
                                        </Table.Row>
                                    */}

                                    <Table.Row>
                                        <Table.Cell>
                                            Email
                                        </Table.Cell>
                                        <Table.Cell>
                                            {email}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Contact Number
                                        </Table.Cell>
                                        <Table.Cell>
                                            {`${contactNoCountryCode} ${contactNo}`}
                                        </Table.Cell>
                                    </Table.Row>
                                    {/*
                                        <Table.Row>
                                            <Table.Cell>
                                                Bank Number
                                            </Table.Cell>
                                            <Table.Cell>
                                                {bankNo}
                                            </Table.Cell>
                                        </Table.Row>
                                    */}

                                    {/*
                                        <Table.Row>
                                            <Table.Cell>
                                                Bank Branch Number
                                            </Table.Cell>
                                            <Table.Cell>
                                                {branchNo}
                                            </Table.Cell>
                                        </Table.Row>
                                    */}
                                    {userMemberType > 0 && 
                                    <Table.Row>
                                        <Table.Cell>
                                            Account Number
                                        </Table.Cell>
                                        <Table.Cell>
                                            { maskedAccountNo }
                                        </Table.Cell>
                                    </Table.Row>}
                                </Table.Body>
                            </Table>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column>
                        <Header as='h4' attached='top' block>
                            Dependents
                        </Header>
                        <Segment attached>
                            {
                                _.map(records, (record) => {
                                    const {name, nric, memberType} = record;
                                    if (memberType === 'd') {
                                        return (
                                            <Table fixed key={nric}>
                                                <Table.Body>
                                                    <Table.Row>
                                                        <Table.Cell>
                                                            Name
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            {name}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                </Table.Body>
                                            </Table>
                                        );
                                    }
                                })
                            }
                        </Segment>
                    </Grid.Column>
                    {props.isnotificationOtp ===2 &&
                    <ProfileBioPlans
                        user={props.user}
                        benefitPlans={props.benefitPlans}
                        benefits={props.benefits}
                        getUserBenefitPlan={props.getUserBenefitPlan}
                        getUserBenefitConfig={props.getUserBenefitConfig}
                        getUserPlanConfigBenefit={props.getUserPlanConfigBenefit}
                    />
                }
                </Grid>
            </Grid.Column>
        </Grid>
    );
}

export default ProfileBio;
